// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2mc5w","row":"ProcedureTreatmentSummary_row__3qxZe"};